// Custom imports:
import hubs from '../../assets/data/hubs.json';
import response from '../../assets/data/response.json';

export const IS_READONLY = {
  // Readonly databases:
};

export const DATABASES = {
  INITIAL_STATE: {
    database: {
      // Databases:
			hubs,
			response,
    },
  },

  SET: 'DATABASES_SET',
};

export const DatabasesReducer = (draft, action) => {
  const { payload, type } = action;
  switch (type) {
    case DATABASES.SET:
      draft.database = {
        ...draft.database,
        ...payload,
      };
      break;

    default:
      return draft;
  }
};
